import { DownloadButtonResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostClientRenewalsPack extends BaseAdapter<DownloadButtonResponse> implements AdapterInterface {
  rawResponse: DownloadButtonResponse;

  async adaptResponse(request: { liftClientDisplayName: string }): Promise<string> {
    await this.fetchApiResponse('/api/client-renewals-pack', HTTPMethod.Post, { lift_client_display_name: request.liftClientDisplayName });
    return this.rawResponse.signed_url;
  }
}
